var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pager__ml_SP"},[_c('v-pagination',{attrs:{"length":_vm.length,"total-visible":7,"prev-icon":"mdi-chevron-double-left","next-icon":"mdi-chevron-double-right","color":"#DB4627","id":"custom_pagination"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }